import { useQuery, UseQueryResult } from '@tanstack/react-query';
import Api from '../api/Api';
import useAuthStore from '../store/authStore';
import { ShoppingResult } from '../types/shopping';
import { QUERY_KEYS } from './queryKeys';

export default function useGetShoppingCartQuery(
  checkStatus = false,
  withPrice = false,
  options?: { enabled?: boolean }
): UseQueryResult<ShoppingResult, Error> {
  const isAuthenticated = useAuthStore((store) => store.isAuthenticated());

  return useQuery({
    queryKey: [QUERY_KEYS.cart.getShoppingCart, { checkStatus, withPrice }],
    enabled: (options?.enabled ?? true) && isAuthenticated,
    queryFn: async () => {
      if (!isAuthenticated) return { shoppingItems: {} } as ShoppingResult;

      try {
        return await Api.shopping.GetShoppingCart(checkStatus, withPrice);
      } catch (error) {
        console.error('Error fetching shopping cart:', error);
        throw error;
      }
    },
  });
}
